module.exports = __webpack_public_path__ + "assets/img/warrior-name-1aeb4e46.png";